import { useState } from "react";
import shortid from "shortid";
import Anchor from "./Anchor";
import "./css/Collapsible.css";

export default function Collapsible({
  id,
  children,
  summary,
  className,
  ...props
}) {
  const [collapsed, setCollapsed] = useState(true);
  const handleClick = (event) => {
    event.preventDefault();
    setCollapsed((previous) => !previous);
  };
  const computedClassName = [
    "collapse",
    (!collapsed && "in") || "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  const iconClass = ["fa", (!collapsed && "fa-caret-up") || "fa-caret-down"]
    .join(" ")
    .trim();
  return (
    <div className="collapsible">
      <Anchor aria-expanded={!collapsed} onClick={handleClick}>
        {summary}
        <i className={iconClass}></i>
      </Anchor>
      <div id={id} className={computedClassName}>
        {children}
      </div>
    </div>
  );
}

Collapsible.defaultProps = {
  className: "",
  id: shortid(),
};
